import { render, staticRenderFns } from "./CartAddressItem.vue?vue&type=template&id=a5d8d5ca&scoped=true"
import script from "./CartAddressItem.vue?vue&type=script&lang=js"
export * from "./CartAddressItem.vue?vue&type=script&lang=js"
import style0 from "./CartAddressItem.vue?vue&type=style&index=0&id=a5d8d5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d8d5ca",
  null
  
)

export default component.exports